import { takeLatest, call, put } from 'redux-saga/effects';
import memberAdminApi from 'api/employee/memberAdminApi';
import * as idChangeActions from 'redux/ducks/personalInformation/idChangesDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';

export function* getCheckBeforeChange() {
  try {
    const response = yield call(memberAdminApi.getCheckBeforeChange);
    yield put(idChangeActions.getCheckBeforeChangeSuccess(response));
  } catch (error) {
    yield put(idChangeActions.getCheckBeforeChangeFail(error));
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getCheckIdValidate({ payload }) {
  try {
    const response = yield call(memberAdminApi.getIdValidation, payload);
    yield call(memberAdminApi.getIdCheck, payload);
    yield put(idChangeActions.getCheckIdValidateSuccess(response));
  } catch (error) {
    yield put(idChangeActions.getCheckIdValidateFail(error));
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* modifyChangeId({ payload }) {
  try {
    const response = yield call(memberAdminApi.modifyIdChange, payload);
    yield put(idChangeActions.modifyChangeIdSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* modifyIdComplete({ payload: modifyIdInformation }) {
  try {
    const response = yield call(memberAdminApi.modifyIdComplete, modifyIdInformation);
    yield put(idChangeActions.modifyIdCompleteSuccess(response));
  } catch (error) {
    yield put(idChangeActions.modifyIdCompleteFail(error));
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export default function* idChangeSaga() {
  yield takeLatest(idChangeActions.getCheckBeforeChange, getCheckBeforeChange);
  yield takeLatest(idChangeActions.getCheckIdValidate, getCheckIdValidate);
  yield takeLatest(idChangeActions.modifyChangeId, modifyChangeId);
  yield takeLatest(idChangeActions.modifyIdComplete, modifyIdComplete);
}
